// React Basic and Bootstrap
import React, { useEffect } from "react"

// Import Generic components
import Section from "../../components/Academy/section"
import Feature from "../../components/Academy/Feature"
import AboutAcademy from "../../components/Academy/aboutAcademy"
import Layout from "../../components/Layout/layout"
import Services from "../../components/Academy/Services"
import SectionBeforeFooter from "../../components/Academy/SectionBeforeFooter"
import Seo from "../../components/Academy/Seo"

const Index = () => {
  const scrollNavigation = () => {
    var doc = document.documentElement
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
    if (top > 80) {
      document.getElementById("topnav").classList.add("nav-sticky")
    } else {
      document.getElementById("topnav").classList.remove("nav-sticky")
    }
  }

  useEffect(() => {
    document.body.classList = ""
    window.addEventListener("scroll", scrollNavigation, true)

    // clean up function
    return () => {
      // Make sure to remove the DOM listener when the component is unmounted.
      window.removeEventListener("scroll", scrollNavigation, true)
    }
  }, [])

  return (
    <Layout>
      {/* SEO */}
      <Seo />

      {/* Hero Start */}
      <Section />

      {/* Feature */}
      <Feature />

      {/* About Academy */}
      <AboutAcademy />

      <Services />

      {/* SectionBeforeFooter */}
      <SectionBeforeFooter />
    </Layout>
  )
}

export default Index
